export default __webpack_public_path__ + "static/media/check.ba5210a4.svg";